<template>
  <div class="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
      size="small"
    >
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.type')" prop="user_type">
          <el-select v-model="ruleForm.user_type" :placeholder="$t('addressForm.placeholder.selectType')" style="width: 100%">
            <el-option :label="$t('addressForm.senderAddress')" :value="1"></el-option>
            <el-option :label="$t('addressForm.recipientAddress')" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.realname')" prop="realname">
          <el-input v-model="ruleForm.realname" :placeholder="$t('addressForm.placeholder.inputRealname')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.company')" prop="company">
          <el-input v-model="ruleForm.company" :placeholder="$t('addressForm.placeholder.inputCompany')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.country')" prop="country">
          <el-select v-model="ruleForm.country" :placeholder="$t('addressForm.placeholder.selectCountry')" style="width: 100%" @change="handleChange">
            <el-option v-for="(item,index) in countryList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.province')" prop="province">
          <el-select v-model="ruleForm.province" :placeholder="$t('addressForm.placeholder.selectProvince')" style="width: 100%">
            <el-option v-for="(item,index) in provinceList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.city')" prop="city">
          <el-input v-model="ruleForm.city" :placeholder="$t('addressForm.placeholder.inputCity')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.zcode')" prop="zcode">
          <el-input v-model="ruleForm.zcode" :placeholder="$t('addressForm.placeholder.inputZcode')" @blur="getCityInfo()"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.address1')" prop="address_one">
          <el-input v-model="ruleForm.address_one" :placeholder="$t('addressForm.placeholder.inputAddress1')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.address2')" prop="address_two">
          <el-input v-model="ruleForm.address_two" :placeholder="$t('addressForm.placeholder.inputAddress2')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.mobile')" prop="mobile">
          <el-input v-model="ruleForm.mobile" :placeholder="$t('addressForm.placeholder.inputMobile')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item :label="$t('addressForm.email')" prop="email">
          <el-input v-model="ruleForm.email" :placeholder="$t('addressForm.placeholder.inputEmail')"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
      <!-- 
      <el-form-item prop="is_default">
        <el-checkbox v-model="ruleForm.is_default" :checked="ruleForm.is_default == 1 ? true : false" :true-label="1" :false-label="0" name="is_default">{{ $t('addressForm.setDefaultAddress') }}</el-checkbox>
      </el-form-item> -->
      <el-form-item style="text-align: right;">
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">{{ $t('addressForm.submit') }}</el-button>
        <el-button size="small" @click="resetForm('ruleForm')">{{ $t('addressForm.reset') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addressAdd, addressUpdate } from '@/api/address'
import { City } from '@/api/common'
import { validatenull, transformCountryCity, provinceListValue } from "@/common/common.js"
import { cityInfo } from "@/api/order"
export default {
  props:{
    record: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      ruleForm: {
        company: '',
        address_two: '',
        email: ''
      },
      rules: {
        user_type: [{ required: true, message: this.$t('addressForm.validate.requiredType'), trigger: "change" }],
        realname: [{ required: true, message: this.$t('addressForm.validate.requiredRealname'), trigger: "blur" }],
        address_one: [{ required: true, message: this.$t('addressForm.validate.requiredAddress1'), trigger: 'blur' }],
        country: [{ required: true, message: this.$t('addressForm.validate.requiredCountry'), trigger: "change" }],
        province: [{ required: true, message: this.$t('addressForm.validate.requiredProvince'), trigger: "change" }],
        city: [{ required: true, message: this.$t('addressForm.validate.requiredCity'), trigger: "blur" }],
        zcode: [{ required: true, message: this.$t('addressForm.validate.requiredZcode'), trigger: "blur" }],
        mobile: [{ required: true, message: this.$t('addressForm.validate.requiredMobile'), trigger: "blur" }]
      },
      countryList: [],// 国家-城市
      provinceList: [],// 国家-城市
      id:''
    };
  },
  mounted(){
    if(!validatenull(this.record)){
      this.id = this.record.id
      this.getCity(this.record.country)
      
      this.ruleForm = {
        ...this.record,
        province: this.record.province.split("-")[0]
      }
    }else{
      this.getCity()
    }
  },
  methods: {
    // 获取城市
    getCity(country){
      City().then(res => {
        this.countryList = transformCountryCity(res.data)
        if(country){
          this.provinceList = provinceListValue(this.countryList, this.record.country)
        }
      })
    },
    //获取省市县
    handleChange(value) {
      this.provinceList = provinceListValue(this.countryList, value)
      delete this.ruleForm.province
    },
    // 通过邮编获取州城市
    getCityInfo(num){
      if(this.ruleForm.country === 'Panama' && /^\d{1,4}$/.test(this.ruleForm.zcode || '')){
        this.ruleForm.zcode = String(this.ruleForm.zcode).padStart(5, '0')
      }
      if(this.ruleForm.country !== 'United States') return
      cityInfo({
        zcode: this.ruleForm.zcode
      }).then(res => {
        if(res.code == 1){
          this.ruleForm.country = 'United States'
          this.ruleForm.province = res.data.province
          this.ruleForm.city = res.data.city
          this.provinceList = provinceListValue(this.countryList, this.ruleForm.country)
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = this.ruleForm
          if(this.id){
            addressUpdate({
              address_id:this.id,
              user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
              ...form
            }).then(res => {
              if(res.code == 1){
                this.$message.success(res.msg)
                this.$emit('ok')
              }else{
                this.$message.error(res.msg)
              }
            }).catch(err => {
              this.$message.error(err.msg)
            })
          }else{
            addressAdd({
              user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
              ...form
            }).then(res => {
              if(res.code == 1){
                this.$message.success(res.msg)
                this.$emit('ok')
              }else{
                this.$message.error(res.msg)
              }
            }).catch(err => {
              this.$message.error(err.msg)
            })
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {
        company: '',
        address_two: '',
        email: ''
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .code{
    font-size: 14px;
    cursor: pointer;
    color: #409EFF;
    margin-left: 10px;
    flex: 1;
    text-align: right;
    width: 100px;
    float: right;
  }
</style>
